module.exports = __webpack_public_path__ + "img/Palladium_Logo.6312a47c.png";